import { Sparkle } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];

  return (
    <div className="relative overflow-hidden border-y border-cy/10 bg-panel py-6" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee items-center gap-10">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="whitespace-nowrap font-display text-2xl font-bold uppercase tracking-wide text-slate-600 transition-colors duration-300 hover:text-cy">
              {item}
            </span>
            <Sparkle className="h-4 w-4 shrink-0 text-cy/50" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
